import Joi from 'joi';

export const upcomingServiceSchema = Joi.object({
  service_date: Joi.string().required(),
  title: Joi.string().required(),
  additional_information: Joi.string().required()
}).options({
  abortEarly: false
});
